import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import clsx from "clsx";
import { Link } from "react-router-dom";

// Custom.
import Layout from "containers/Layout/Layout";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { useStyles } from "pages/dashboard/styles";
import { DashboardBoxAction } from "pages/dashboard/global";
import VoAuth from "@vocollege/app/dist/modules/VoAuth";
import routes from "pages/routes";

const Statistics: React.FC = (props) => {
  const classes = useStyles();

  const getBox = (title: string, actions: DashboardBoxAction[] = []) => (
    <Grid item xs={12} md={4}>
      <Card elevation={10} className={classes.box}>
        <CardHeader
          title={title}
          className={classes.header}
          titleTypographyProps={{ textAlign: "center" }}
        />
        <CardActions
          sx={(theme) => ({
            justifyContent: "center",
            padding: theme.spacing(2),
          })}
        >
          {actions &&
            actions.length > 0 &&
            actions.map((v: DashboardBoxAction, i: number) => (
              <React.Fragment key={i}>
                {v.url && (
                  <Button
                    size="small"
                    component={Link}
                    to={v.url || ""}
                    color={v.color}
                    variant={v.variant}
                  >
                    {v.label}
                  </Button>
                )}
              </React.Fragment>
            ))}
        </CardActions>
      </Card>
    </Grid>
  );
  return (
    <Layout>
      <Box className={clsx(classes.root, "vo-global__top-bottom-space")}>
        <Grid
          spacing={4}
          alignItems="stretch"
          justifyContent="center"
          container
        >
          {VoAuth.ability.can("list_own_diplomas", "Cert") &&
            VoAuth.ability.can("access_statistics", "Cert") &&
            getBox(routes["statistics.diplomas"].label, [
              {
                label: I18n.get.vocertStatistics.toTheReport,
                url: routes["statistics.diplomas"].path,
                color: "secondary",
                variant: "outlined",
              },
            ])}
          {VoAuth.ability.can("list_own_certificates", "Cert") &&
            VoAuth.ability.can("access_statistics", "Cert") &&
            getBox(routes["statistics.certificates"].label, [
              {
                label: I18n.get.vocertStatistics.toTheReport,
                url: routes["statistics.certificates"].path,
                color: "secondary",
                variant: "outlined",
              },
            ])}
          {VoAuth.ability.can("list_own_tutor_certificates", "Cert") &&
            VoAuth.ability.can("access_statistics", "Cert") &&
            getBox(routes["statistics.tutorCertificates"].label, [
              {
                label: I18n.get.vocertStatistics.toTheReport,
                url: routes["statistics.tutorCertificates"].path,
                color: "secondary",
                variant: "outlined",
              },
            ])}
          {VoAuth.ability.can("list_own_care_assistant_diplomas", "Cert") &&
            VoAuth.ability.can("access_statistics", "Cert") &&
            getBox(routes["statistics.careAssistantDiplomas"].label, [
              {
                label: I18n.get.vocertStatistics.toTheReport,
                url: routes["statistics.careAssistantDiplomas"].path,
                color: "secondary",
                variant: "outlined",
              },
            ])}
          {VoAuth.ability.can(
            "list_own_language_representative_diplomas",
            "Cert",
          ) &&
            VoAuth.ability.can("access_statistics", "Cert") &&
            getBox(routes["statistics.languageRepresentativeDiplomas"].label, [
              {
                label: I18n.get.vocertStatistics.toTheReport,
                url: routes["statistics.languageRepresentativeDiplomas"].path,
                color: "secondary",
                variant: "outlined",
              },
            ])}
          {VoAuth.ability.can(
            "list_own_language_representative_educator_diplomas",
            "Cert",
          ) &&
            VoAuth.ability.can("access_statistics", "Cert") &&
            getBox(
              routes["statistics.languageRepresentativeEducatorDiplomas"].label,
              [
                {
                  label: I18n.get.vocertStatistics.toTheReport,
                  url: routes[
                    "statistics.languageRepresentativeEducatorDiplomas"
                  ].path,
                  color: "secondary",
                  variant: "outlined",
                },
              ],
            )}
        </Grid>
      </Box>
    </Layout>
  );
};

export default Statistics;
